<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

const items = ref([]);

onMounted(async () => {
  try {
    const response = await axios.get(
      "https://mui-kendal.or.id/pengurus/Api/latestNews"
    );
    items.value = response.data.Data;
    } catch (error) {
    console.error("Error fetching slider data:", error);
  }
});
</script>

<template>
  <Swiper :modules="[Navigation]" navigation :slides-per-view="1" :loop="true">
    <SwiperSlide v-for="(item, index) in items" :key="index">
      <div class="slide">
        <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${item.image}`" :alt="item.judul" />
        <!-- <h3>{{ item.judul }}</h3> -->
      </div>
    </SwiperSlide>
  </Swiper>
</template>

<style scoped>
.slide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}
/* .slide img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; 
} */
.slide img {
  width: 100%; /* Lebar penuh */
  height: 400px; /* Tinggi tetap */
  object-fit: cover; /* Memotong gambar agar mengisi area */
  border-radius: 10px; /* Opsional: Membuat sudut melengkung */
}
</style>
